import { Loader } from './component';


export default Loader;
